import { useEffect, useRef } from 'react';
import { ListCalendarEventsResponse } from '@weave/schema-gen-ts/dist/schemas/schedule/v3/calendar_event.pb';
import { createCustomEventSystem } from '@frontend/event';
import { useCalendarStore } from '../../stores/calendar.store';

interface CalendarCustomEvents {
  'focus-appointment': {
    appointmentId: string;
    calendarDate: string;
  };
}

const { triggerCustomEvent, useCustomEventListener: useCalendarCustomEventListener } =
  createCustomEventSystem<CalendarCustomEvents>();

/**
 * Dispatches a custom event to focus on a specific appointment.
 */
const dispatchFocusAppointmentEvent = (data: { appointmentId: string; calendarDate: string; locationId: string }) => {
  triggerCustomEvent('focus-appointment', data);
};

const useFocusCalendarEvent = (calendarEventsData?: ListCalendarEventsResponse, successCallback?: () => void) => {
  const appointmentIdToFocusRef = useRef<string | null>(null);
  const { setCalendarDate } = useCalendarStore(['setCalendarDate']);

  useCalendarCustomEventListener('focus-appointment', (data) => {
    // TODO: set calendar date as per location & appt time
    setCalendarDate(data.calendarDate);
    appointmentIdToFocusRef.current = data.appointmentId;
  });

  useEffect(() => {
    if (!appointmentIdToFocusRef.current) return;
    if (calendarEventsData?.events.find((event) => event.id === appointmentIdToFocusRef.current)) {
      document
        .querySelector(`[data-event-id='${appointmentIdToFocusRef.current}']`)
        ?.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' });

      // after 2 sec delay
      successCallback?.();
    }
  }, [calendarEventsData]);
};

export { dispatchFocusAppointmentEvent, useCalendarCustomEventListener, useFocusCalendarEvent };
